import { useValueConfigSummary } from "./useValueConfigSummary.ts";

interface Props {
  value: unknown;
  /** shift applied to a numeric literal for display (e.g. 1-indexed UI) */
  offset?: number;
}

/**
 * Renders the design-time display of a configured value: a live literal for
 * static values, the advertised title of what a reference points to, nothing
 * when unresolvable.
 */
export const ValueConfigSummaryText = ({ value, offset = 0 }: Props) => {
  const summary = useValueConfigSummary()(value);
  if (summary === undefined) return null;
  const display =
    typeof summary === "boolean"
      ? summary
        ? "True"
        : "False"
      : typeof summary === "number"
        ? summary + offset
        : summary;
  return <>{String(display)}</>;
};
